import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'card-busca',
    templateUrl: './card-busca.component.html',
    styleUrls: ['./card-busca.component.scss'],
    standalone: false
})
export class CardBuscaComponent implements OnInit {

  @Input() maisInfo: any;
  isCollapsed: boolean = true;

  constructor() {

  }

  ngOnInit(): void {
  }

  mais() {
    this.isCollapsed = !this.isCollapsed;
  }

}
